export const ProductPartConstant = {
	GET_ALL: 'PRODUCTPART_GET_ALL',
	GET_ONE: 'PRODUCTPART_GET_ONE',
	UPDATE: 'PRODUCTPART_UPDATE',
	CREATE: 'PRODUCTPART_CREATE',
	DELETE: 'PRODUCTPART_DELETE',
    LOADING: 'PRODUCTPART_LOADING',
    LOADED: 'PRODUCTPART_LOADED',
    ADDUPDATE: 'PRODUCTPART_ADDUPDATE',
};